import { render, staticRenderFns } from "./RouteItem.vue?vue&type=template&id=e1d58c9a&scoped=true&"
import script from "./RouteItem.vue?vue&type=script&lang=js&"
export * from "./RouteItem.vue?vue&type=script&lang=js&"
import style0 from "./RouteItem.vue?vue&type=style&index=0&id=e1d58c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d58c9a",
  null
  
)

export default component.exports